import {Node} from "../../../../../../pkg/slate.js";
export const getNode = (editor, path) => {
  try {
    return Node.get(editor, path);
  } catch (err) {
    return null;
  }
};
